import { IconProps } from '~/components/Icon';

export type CelectOptionCheckProps = IconProps;
export const CelectOptionCheck = ({ className, ...props }: CelectOptionCheckProps) => (
  <svg
    className={className}
    width="28"
    height="29"
    viewBox="0 0 28 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M19.3995 10.9906L11.8271 18.5631L7.70006 14.4361"
      stroke="currentColor"
      strokeWidth="2.54545"
      strokeLinecap="round"
    />
  </svg>
);
